<ng-container *transloco="let t; read: 'accounts'">
@if (!userDetails) {
  <div>
    <div class="flex justify-between h-36">
      <h1 class="text-[25px] font-bold self-center">{{ t('editUser.loading') }}</h1>
    </div>
  </div>
}
@if (userDetails) {
  <div>
    <div class="flex justify-between border-b">
      <h1 class="text-[25px] font-bold">{{ t('common.editingTitle', { name: userDetails.firstName + ' ' + userDetails.lastName }) }}</h1>
      <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
    </div>
    <div mat-dialog-content>
      <form class="grid grid-cols-2 gap-4 gap-x-10 mt-5" [formGroup]="editForm">
        <!-- <div class="col-span-1">
        <h3 class="font-bold text-[16px] mb-2">Work Email</h3>
        <input formControlName="emailName" type="text" class="border-b border-black focus:outline-none w-full">
        <mat-error *ngIf="emailName.touched && emailName.errors?.email" class="text-sm text-red-700 pt-4">
          Input a valid email address.
        </mat-error>
      </div> -->
      <div class="col-span-1">
        <mat-form-field class="bg-white" appearance="fill">
          <h3 class="font-bold text-[16px] required">{{ t('common.workEmail') }}</h3>
          <input matInput formControlName="emailName" type="text"
            class="border-b border-black focus:outline-none w-full">
          @if (emailName.touched && emailName.errors?.email) {
            <mat-error class="text-sm text-red-700 pt-4">
              {{ t('common.invalidEmail') }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-span-1">
        <label>{{ t('common.workTitle') }}</label>
        <p>{{userDetails.jobTitle}}</p>
      </div>
      <div class="col-span-1">
        <h3 class="font-bold text-[16px]">{{ t('common.accountCreated') }}</h3>
        <p>{{userDetails.createdOn | localizedDate: 'M/d/yyyy' }}</p>
      </div>
      <div class="col-span-1">
        <h3 class="font-bold text-[16px]">{{ t('common.lastLogin') }}</h3>
        <p>{{userDetails.lastLogin ? (userDetails.lastLogin | localDate | localizedDate: 'M/d/yyyy') : '' }}</p>
      </div>
      <div class="col-span-1">
        <drdp-select-status [initialStatusId]="statusTypeId.value" (status)="handleChosenAccountStatus($event)"
          [required]="true">
        </drdp-select-status>
      </div>
      <div class="col-span-1">
        <h3 class="font-bold text-[16px]">{{ t('common.statusModifiedDate') }}</h3>
        <p>{{userDetails.modifiedOn | localizedDate: 'M/d/yyyy'}}</p>
      </div>
      <div class="col-span-1">
        <h3 class="font-bold text-[16px]">{{ t('common.statusModifiedBy') }}</h3>
        <p>{{userDetails.modifiedName}}</p>
      </div>
      <div class="col-span-1">
        <h3 class="font-bold text-[16px]">{{ t('editUser.passwordStatus') }}</h3>
        <p>
          {{ t('editUser.passwordLastChanged', { date: userDetails.passwordChangedOn ?
          (userDetails.passwordChangedOn | localizedDate: 'M/d/yyyy') : '' }) }}
        </p>
      </div>
      <div class="col-span-1">
        <drdp-select-state [initialStateId]="stateId.value" (state)="handleChosenState($event)" [required]="true">
        </drdp-select-state>
      </div>
      <div class="col-span-1">
        <drdp-select-agency [initialAgencyId]="agencyId.value" (agency)="handleChosenAgency($event)"
          [stateId]="stateId.value">
        </drdp-select-agency>
      </div>
      <div class="col-span-1">
        <drdp-select-site [initialSiteIds]="siteIds.value" (site)="handleChosenSites($event)"
          [agencyId]="agencyId.value" [multiSelect]="true" [multiSelectInitVals]="true"
          [required]="agencyId.value" [isValid]="siteIds.valid">
        </drdp-select-site>
      </div>
      <div class="col-span-1">
        <drdp-select-county [initialCountyIds]="countyIds.value" (county)="handleChosenCounties($event)"
          [stateId]="stateId.value" [multiSelect]="true" [multiSelectInitVals]="true">
        </drdp-select-county>
      </div>
      <div class="col-span-1">
        <drdp-select-grantee [initialGranteeId]="granteeAgencyId.value"
          (agency)="handleChosenGranteeAgency($event)" [stateId]="stateId.value">
        </drdp-select-grantee>
      </div>
      <div class="col-span-1">
        <drdp-select-contractor [initialContractorId]="contractorAgencyId.value"
          (agency)="handleChosenContractorAgency($event)" [stateId]="stateId.value">
        </drdp-select-contractor>
      </div>
    </form>
    <div class="col-span-2 items-center w-[100%]">
      <label class="required">{{ t('common.roles') }}</label>
      <!-- Role names and tooltips below are server-supplied: localized by the API, not by Transloco. -->
      <div class="grid grid-cols-2 gap-4 gap-x-10 mt-2 pb-3">
        <div class="col-span-1 items-center w-[100%]">
          <label>{{ t('common.roleGroups.userRoles') }}</label>
          <div class="flex flex-col">
            @for (role of roleList; track role) {
              <div>
                @if (role.roleGroupId === roleGroup.UserRoles) {
                  <div>
                    <p>
                      <mat-checkbox #roleCheckbox [formControl]="roleForm?.get(role.id.toString())" [value]="role.id.toString()" (change)="handleChosenRoles(role.id)"
                        color="primary">
                      </mat-checkbox>
                      {{role.roleName}}
                      @if (role.tooltipInformation) {
                        <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                      }
                    </p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-span-1 items-center w-[100%]">
          <label>{{ t('common.roleGroups.enrollmentUser') }}</label>
          <div class="flex flex-col">
            @for (role of roleList; track role) {
              <div>
                @if (role.roleGroupId === roleGroup.EnrollmentUser) {
                  <div>
                    <p>
                      <mat-checkbox #roleCheckbox [formControl]="roleForm?.get(role.id.toString())"  [value]="role.id.toString()" (change)="handleChosenRoles(role.id)"
                        color="primary">
                      </mat-checkbox>
                      {{role.roleName}}
                      @if (role.tooltipInformation) {
                        <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                      }
                    </p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-span-1 items-center w-[100%]">
          <label>{{ t('common.roleGroups.administratorRoles') }}</label>
          <div class="flex flex-col">
            @for (role of roleList; track role) {
              <div>
                @if (role.roleGroupId === roleGroup.AdministratorRoles) {
                  <div>
                    <p>
                      <mat-checkbox #roleCheckbox [formControl]="roleForm?.get(role.id.toString())"  [value]="role.id.toString()" (change)="handleChosenRoles(role.id)"
                        color="primary">
                      </mat-checkbox>
                      {{role.roleName}}
                      @if (role.tooltipInformation) {
                        <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                      }
                    </p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-span-1 items-center w-[100%]">
          <label>{{ t('common.roleGroups.stateUsers') }}</label>
          <div class="flex flex-col">
            @for (role of roleList; track role) {
              <div>
                @if (role.roleGroupId === roleGroup.StateUsers) {
                  <div>
                    <p>
                      <mat-checkbox #roleCheckbox [formControl]="roleForm?.get(role.id.toString())"  [value]="role.id.toString()" (change)="handleChosenRoles(role.id)"
                        color="primary">
                      </mat-checkbox>
                      {{role.roleName}}
                      @if (role.tooltipInformation) {
                        <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                      }
                    </p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-span-1 items-center w-[100%]">
          <label>{{ t('common.roleGroups.leadAdminRoles') }}</label>
          <div class="flex flex-col">
            @for (role of roleList; track role) {
              <div>
                @if (role.roleGroupId === roleGroup.LeadAdminRoles) {
                  <div>
                    <p>
                      <mat-checkbox #roleCheckbox [formControl]="roleForm?.get(role.id.toString())" [value]="role.id.toString()"  (change)="handleChosenRoles(role.id)"
                        color="primary">
                      </mat-checkbox>
                      {{role.roleName}}
                      @if (role.tooltipInformation) {
                        <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                      }
                    </p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-span-1 items-center w-[100%]">
          <label>{{ t('common.roleGroups.powerUserRoles') }}</label>
          <div class="flex flex-col">
            @for (role of roleList; track role) {
              <div>
                @if (role.roleGroupId === roleGroup.PowerUserRoles) {
                  <div>
                    <p>
                      <mat-checkbox #roleCheckbox [formControl]="roleForm.get(role.id.toString())" [value]="role.id.toString()"  (change)="handleChosenRoles(role.id)"
                        color="primary">
                      </mat-checkbox>
                      {{role.roleName}}
                      @if (role.tooltipInformation) {
                        <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                      }
                    </p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-span-1 items-center w-[100%]">
          <label>{{ t('common.roleGroups.systemPowerUser') }}</label>
          <div class="flex flex-col">
            @for (role of roleList; track role) {
              <div>
                @if (role.roleGroupId === roleGroup.SystemPowerUser) {
                  <div>
                    <p>
                      <mat-checkbox #roleCheckbox [formControl]="roleForm?.get(role.id.toString())"  [value]="role.id.toString()" (change)="handleChosenRoles(role.id)"
                        color="primary">
                      </mat-checkbox>
                      {{role.roleName}}
                      @if (role.tooltipInformation) {
                        <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                      }
                    </p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-row justify-end">
    <drdp-btn mat-button mat-dialog-close [color]="'cancel'">{{ t('common.cancel') }}</drdp-btn>
    <drdp-btn class="mx-3" [color]="'red'" (click)="undoChanges()">{{ t('editUser.undoChanges') }}</drdp-btn>
    <drdp-btn [disabled]="editForm.invalid" (click)="submit()">{{ t('editUser.saveEdit') }}</drdp-btn>
  </div>
</div>
}
</ng-container>
